import { Reducer } from 'redux';
import { ScheduleState, ScheduleTypes } from './types';

export const INITIAL_STATE: ScheduleState = {
  scheduleList: [],
  error: false,
  loading: false,
};

const reducer: Reducer<ScheduleState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // LIST SCHEDULES
    case ScheduleTypes.LIST_SCHEDULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        scheduleList: INITIAL_STATE.scheduleList,
      };
    case ScheduleTypes.LIST_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        scheduleList: action.payload.scheduleList,
        totalCount: action.payload.totalCount,
      };
    case ScheduleTypes.LIST_SCHEDULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        scheduleList: INITIAL_STATE.scheduleList,
      };

    // CREATE SCHEDULE
    case ScheduleTypes.CREATE_SCHEDULE_REQUEST:
      return { ...state, loading: true, error: false };
    case ScheduleTypes.CREATE_SCHEDULE_SUCCESS:
      return { ...state, loading: false, error: false };
    case ScheduleTypes.CREATE_SCHEDULE_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE SCHEDULE
    case ScheduleTypes.UPDATE_SCHEDULE_REQUEST:
      return { ...state, loading: true, error: false };
    case ScheduleTypes.UPDATE_SCHEDULE_SUCCESS:
      return { ...state, loading: false, error: false };
    case ScheduleTypes.UPDATE_SCHEDULE_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE SCHEDULE
    case ScheduleTypes.DELETE_SCHEDULE_REQUEST:
      return { ...state, loading: true, error: false };
    case ScheduleTypes.DELETE_SCHEDULE_SUCCESS:
      return { ...state, loading: false, error: false };
    case ScheduleTypes.DELETE_SCHEDULE_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
